import React from 'react';
import styles from './banner.module.css';
import { HiMenu } from 'react-icons/hi';
import { VscClose } from 'react-icons/vsc';

export default function BannerSection() {
  const logoRef = React.useRef(null);
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  return (
    <div className={styles.wrapper}>
      <header>
        <button onClick={() => setMenuIsOpen((val) => !val)} className={styles.mobileNavToggle}>
          {menuIsOpen ? <VscClose /> : <HiMenu />}
        </button>
        <nav className={`${menuIsOpen ? styles.open : 'nel'}`}>
          <ul>
            <li>
              <a href="#sobre-nosotros">Sobre nosotros</a>
            </li>
            <li>
              <a href="#tecnologias">Tecnologías</a>
            </li>
            <li>
              <a href="#proyectos">Proyectos</a>
            </li>
            <li>
              <a href="#desarrolladores">Desarrolladores</a>
            </li>
          </ul>
        </nav>
      </header>
      <section>
        <header>
          <h1>Bienvenido a Gotlim</h1>
        </header>
        <div className={styles.logoCodeContainer}>
          <img src="favicon.ico" alt="Gotlim Logo" className={styles.gotlimLogo} ref={logoRef} />
          <img src="light-blue.png" alt="Light" className={styles.logoLight} />
          <div className={styles.carbon}>
            <img src="gotlim-json.png" alt="Gotlim JSON" />
          </div>
          <div className={styles.line}></div>
        </div>
      </section>
    </div>
  );
}
